import { render, staticRenderFns } from "./CollabAssignmentForm.vue?vue&type=template&id=c6b27024&"
import script from "./CollabAssignmentForm.vue?vue&type=script&lang=js&"
export * from "./CollabAssignmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports